// @ts-nocheck
export default {
  getSearchItems ({ search }) {
    return search.items
  },
  getSearchMeta ({ search }) {
    return search.meta
  }
}
